import { useRef, useState } from "react";
import { useCustomDispatch, useCustomSelector } from "../../hooks";
import * as storage from "../../state/storage";
import AppendButton from "./append-button";
import Form, { InputField, SubmitButton } from "./form";
import Header from "./header";
import { useNavigate } from "react-router-dom";

export default function Main() {
  const [label, setLabel] = useState<string>(
    localStorage.getItem("label") ?? "current"
  );

  const navigate = useNavigate();

  const storages = useCustomSelector((state) => state.storage);
  const dispatch = useCustomDispatch();

  const dummyRef = useRef(null);

  const handleInputFieldUpdate = (index: number, value: string) => {
    dispatch(storage.actions.update({ index, value }));
  };

  const deleteStorgeElement = (index: number) => {
    dispatch(storage.actions.remove(index));
  };

  const handleSubmit = (e: any) => {
    dispatch(storage.actions.save(label));
    dispatch(storage.actions.save("current"));
    navigate("randomize", { replace: true });
  };

  const handleLabelUpdate = (value: string) => {
    setLabel(value);
    localStorage.setItem("label", value);
  };

  return (
    <>
      <Header onLabelUpdate={handleLabelUpdate} label={label} />
      <Form onSubmit={handleSubmit} action="/randomize">
        <ul
          style={{
            minHeight: "calc(100vh - 350px)",
            maxHeight: "calc(100vh - 350px)",
          }}
          className="flex gap-3 flex-col overflow-hidden overflow-y-auto"
        >
          {storages.map(({ value, key }, index) => (
            <li key={key}>
              <InputField
                name="item"
                value={value}
                onChange={(e) => handleInputFieldUpdate(index, e.target.value)}
                onDelete={() => deleteStorgeElement(index)}
              />
            </li>
          ))}
          <div ref={dummyRef} />
        </ul>
        <div className="my-3">
          <AppendButton dummyRef={dummyRef} />
        </div>
        <SubmitButton>Randomize</SubmitButton>
      </Form>
    </>
  );
}
